import { Box } from 'src/shared/components/Box';
import styled from 'styled-components';
import { Icon, IconProps } from '../Icon';

export type BufferingPros = Omit<IconProps, 'name'>;

export const Buffering = ({ size = '2em', ...others }: BufferingPros) => (
  <Box
    left="50%"
    position="absolute"
    top="50%"
    transform="translate(-50%, -50%)"
  >
    <SpinningIcon
      data-testid="spinning-icon"
      size={size}
      color="primary.500"
      {...others}
      name="buffering"
    ></SpinningIcon>
  </Box>
);

const SpinningIcon = styled(Icon)`
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
`;
